interface ICheckboxCardProps {
  checkboxName: string;
  label: string | React.ReactNode;
  value: string;
  checked?: boolean;
  handleChecked?: (value: string | null) => void;
  children?: React.ReactNode;
  disabled?: boolean;
  dataTestId?: string;
  inputClassName?: string;
  labelClassName?: string;
}

const CheckboxCard: React.FC<ICheckboxCardProps> = ({
  checkboxName,
  label,
  value,
  children,
  checked,
  handleChecked,
  disabled = false,
  dataTestId,
  inputClassName,
  labelClassName,
}) => {
  return (
    <label
      htmlFor={value}
      className={`
        tw-relative
        tw-flex
        tw-h-[104px]
        tw-w-full
        tw-min-w-[130px]
        tw-max-w-[100%]
        tw-cursor-pointer
        tw-flex-col
        tw-justify-center
        tw-rounded-lg
        tw-border-[1px]
        tw-border-solid
        tw-border-blue-200
        tw-px-3
        tw-outline
        tw-outline-[1px]
        tw-outline-white
        tw-duration-300
        tw-ease-out
        [&:has(>input:disabled)]:tw-lf-checkbox-disabled
        last:tw-mb-0
        hover:tw-border-yellow-600
        hover:tw-outline-yellow-600
        desktop:tw-h-[120px]
        [&:has(>input:checked)]:tw-border-yellow-600
        [&:has(>input:checked)]:tw-outline-yellow-600
        ${labelClassName ?? ''}
      `}
      data-testid={dataTestId}
    >
      <input
        name={checkboxName}
        id={value}
        type="checkbox"
        className={`tw-peer tw-lf-checkbox tw-absolute tw-right-[6px] tw-top-[6px] ${
          inputClassName ?? ''
        }`}
        value={value}
        checked={checked}
        onChange={(e) => {
          handleChecked?.(e.target.value);
        }}
        disabled={disabled}
      />
      {children}
      <span
        className={`tw-lf-caption-regular tw-mt-3 tw-self-center !tw-text-center tw-leading-[21px] desktop:tw-lf-body-regular-sm`}
      >
        {label}
      </span>
    </label>
  );
};

export default CheckboxCard;
